import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-graphics-nav',
  templateUrl: './graphics-nav.component.html',
  styleUrls: ['./graphics-nav.component.scss'],
})
export class GraphicsNavComponent implements OnInit {
  @Input('initial') initial;
  @Output() private eventClick = new EventEmitter<void>();

  // pasado como [passedParams] al swiper-container: así se reaplica solo cada vez que Ionic
  // reconecta la página al stack de navegación (el swiper-element se destruye en cada disconnect).
  public navSlideOpts;
  currentPage: string;

  idProject: any;
  projectName: any;
  power: any;
  technology: any;
  location: any;
  data: any;

  constructor() {}

  ngOnInit() {
    switch (this.initial) {
      case 0:
        this.currentPage = 'daily-production';
        break;
      case 1:
        this.currentPage = 'daily-income';
        break;
      case 2:
        this.currentPage = 'yearly-revenues';
        break;
      case 3:
        this.currentPage = 'production';
        break;
    }
    this.createSlider();
  }

  createSlider() {
    // Swiper recalcula estos parámetros solo con el resize, vía `breakpoints` (min-width).
    this.navSlideOpts = {
      initialSlide: this.initial,
      speed: 1000,
      width: 450,
      effect: 'slide', // slide, fade, cube, coverflow, flip
      slidesPerView: 4,
      grabCursor: true,
      slideToClickedSlide: true,
      freeMode: true,
      centeredSlides: true,
      breakpoints: {
        750: {
          slideToClickedSlide: false,
          freeMode: false,
          centeredSlides: false,
        }
      }
    };
  }

  changePage(page) {
    this.currentPage = page;
    this.eventClick.emit(page);
  }
}
